import { useState } from 'react';
import { episodes } from '@/mocks/animeData';

export default function EpisodeRecaps() {
  const [active, setActive] = useState<string | null>('01');

  return (
    <section id="episodes" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
            <i className="ri-list-check-2"></i>分集解说
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">12 集重点速览</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            点开任意一集，快速掌握本集讲了什么、有哪些关键伏笔和名场面。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {episodes.map((ep) => {
            const isOpen = active === ep.num;
            return (
              <div
                key={ep.num}
                className={`rounded-3xl border transition-colors ${
                  isOpen ? 'border-primary-200 bg-background-100' : 'border-background-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setActive(isOpen ? null : ep.num)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full font-heading text-sm ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      {ep.num}
                    </span>
                    <div>
                      <h3 className="text-sm font-bold text-foreground-950">{ep.title}</h3>
                      <span className="text-[11px] text-foreground-600">第 {parseInt(ep.num, 10)} 集</span>
                    </div>
                  </div>
                  <i
                    className={`text-lg text-foreground-600 transition-transform ${isOpen ? 'rotate-180' : ''} ri-arrow-down-s-line`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{ep.summary}</p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {ep.highlights.map((h) => (
                        <span
                          key={h}
                          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-bold text-accent-700"
                        >
                          <i className="ri-sparkling-2-line"></i>{h}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}